import {customElement, property} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {unsafeSVG} from "lit/directives/unsafe-svg.js";
import PLUS_SIGN from "../../../../../svgpictograms/plus.svg";
import Styles from "./inlineModalDialogIndicator.lit.scss";
import {DialogAnchorTemplateContent} from "./dialogAnchorTemplateContent";

@customElement("eop-inline-modal-dialog-indicator")
export class EopInlineModalDialogIndicator extends DialogAnchorTemplateContent {

    public static readonly styles = Styles;

    @property({attribute: "title"})
    private buttonTitle: string;

    public render(): TemplateResult {
        return html`
            <button type=button class="indicator-link" title=${this.buttonTitle}>
                <span class="indicator-plus" @click=${this.openDialog}>
                    ${unsafeSVG(PLUS_SIGN)}
                </span>
            </button>`;
    }
}